
































































































import {Component, Prop, Model} from 'vue-property-decorator';
import CommonVue from '../models/commonVue';
import {BusEvent} from '@/models/bus';

import Modal from '@/components/Modal.vue';
import EditIcon from '../components/icons/EditIcon.vue';
import MetricPoints from "@/api/metricPoints";
import {InternationalizedField} from "@/api/common";
import InterfaceElement from '@/api/interfaceElement';
import LessonVideoInfo from "../api/lessonVideoInfo";

@Component({
    components: {
        'modal': Modal,
        'edit-icon': EditIcon,
    },
})
export default class FieldLessonVideoInfo extends CommonVue {
    @Model('update') public lesson_video_info_list!: LessonVideoInfo[];
    @Prop({type: Boolean, default: false}) public disabled?: boolean;

    public lesson_video_info: LessonVideoInfo = null;
    public isNewElement: boolean = false;
    public showModal: boolean = false;

    // noinspection JSMethodCanBeStatic
    public edit(element: LessonVideoInfo) {
        this.lesson_video_info = element;
        this.isNewElement = false;
        this.showModal = true;
    }

    public newLessonVideoInfo() {
        this.lesson_video_info = new LessonVideoInfo();
        this.isNewElement = true;
        this.showModal = true;
    }

    public saveClicked() {
        if (!this.lesson_video_info) {
            return;
        }

        this.busy = true;

        try {
            this.checkMandatoryFields();
            if (this.isNewElement) {
                this.lesson_video_info_list.push(this.lesson_video_info);
            }
            this.busy = false;
            this.showModal = false;
        } catch (e) {
            this.busy = false;
            this.$bus.$emit(BusEvent.ERROR, 'Could not save lesson video info', e);
        }
    }

    public checkMandatoryFields() {
        // Check if text is filled
        if(!this.lesson_video_info.start_time || !this.lesson_video_info.end_time) {
            throw Error('Please insert the start and end time.');
        }
    }

    public deleteClicked() {
        const newList = this.lesson_video_info_list.filter((value) => {
            return value !== this.lesson_video_info;
        });

        this.$emit('update', newList);
        this.showModal = false;
    }

}

